import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A1128]">
        <div className="text-amber-400 font-mono text-sm tracking-widest uppercase">
          Verifying credentials…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/contact/admin" replace />;
  return children;
}
